// i18n.ts
import i18next from 'i18next'
import hebrew from './languages/hebrew.json'
import english from './languages/english.json'
import { ELanguage } from 'types/enums/ELanguage'
import { LANGUAGE } from 'constants/layout'

i18next.init({
  resources: {
    [ELanguage.HEBREW]: {
      translation: hebrew,
    },
    [ELanguage.ENGLISH]: {
      translation: english,
    },
  },
  lng: sessionStorage.getItem(LANGUAGE) || ELanguage.HEBREW,
  fallbackLng: ELanguage.HEBREW,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

export default i18next
